import { Chip, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  warn: {
    backgroundColor: "rgba(247, 134, 42, 0.2)",
    color: "#F7862A"
  },
  info: {
    backgroundColor: "rgba(82, 88, 221, 0.2)",
    color: "#5258DD"
  },
  error: {
    backgroundColor: theme.palette.error.opacity,
    color: theme.palette.secondary.main
  }
}));

const ChipStatus = ({
  size = "small",
  color,
  type = "success",
  label,
  className,
  style
}) => {
  color = type === "success" || type === "primary" ? "primary" : color;
  const classes = useStyles();

  return (
    <Chip
      size={size}
      color={color}
      label={label}
      className={clsx(classes[type], className)}
      style={style}
    />
  );
};

export default ChipStatus;
